import type { UnitSystem } from '../preferences'
import './settings-dialog.css'

export function SettingsDialog({
  open,
  unitSystem,
  followLatestPosition,
  showLivePositionInfo,
  onChange,
  onFollowLatestPositionChange,
  onShowLivePositionInfoChange,
  onClose,
}: {
  open: boolean
  unitSystem: UnitSystem
  followLatestPosition: boolean
  showLivePositionInfo: boolean
  onChange: (unitSystem: UnitSystem) => void
  onFollowLatestPositionChange: (enabled: boolean) => void
  onShowLivePositionInfoChange: (enabled: boolean) => void
  onClose: () => void
}) {
  if (!open) return null

  return (
    <div className="settings-overlay" role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose()
    }}>
      <section className="settings-dialog" role="dialog" aria-modal="true" aria-labelledby="settings-title">
        <div className="settings-dialog__heading">
          <div>
            <p>Preferences</p>
            <h2 id="settings-title">Settings</h2>
          </div>
          <button type="button" aria-label="Close settings" onClick={onClose}>×</button>
        </div>
        <fieldset>
          <legend>Units</legend>
          <label className={unitSystem === 'metric' ? 'settings-option settings-option--selected' : 'settings-option'}>
            <input type="radio" name="unit-system" value="metric" checked={unitSystem === 'metric'} onChange={() => onChange('metric')} />
            <span><strong>Metric</strong><small>Kilometres, km/h and metres</small></span>
          </label>
          <label className={unitSystem === 'us' ? 'settings-option settings-option--selected' : 'settings-option'}>
            <input type="radio" name="unit-system" value="us" checked={unitSystem === 'us'} onChange={() => onChange('us')} />
            <span><strong>US units</strong><small>Miles, mph and feet</small></span>
          </label>
        </fieldset>
        <fieldset>
          <legend>Live map</legend>
          <label className={followLatestPosition ? 'settings-option settings-option--selected' : 'settings-option'}>
            <input
              type="checkbox"
              checked={followLatestPosition}
              onChange={(event) => onFollowLatestPositionChange(event.currentTarget.checked)}
            />
            <span>
              <strong>Follow latest position</strong>
              <small>Automatically pan when a live trip receives a new position</small>
            </span>
          </label>
          <label className={showLivePositionInfo ? 'settings-option settings-option--selected' : 'settings-option'}>
            <input
              type="checkbox"
              checked={showLivePositionInfo}
              onChange={(event) => onShowLivePositionInfoChange(event.currentTarget.checked)}
            />
            <span>
              <strong>Show live position info</strong>
              <small>Display speed and position age above the marker on live trips</small>
            </span>
          </label>
        </fieldset>
        <button className="settings-dialog__done" type="button" onClick={onClose}>Done</button>
      </section>
    </div>
  )
}
